import { createSelector } from 'reselect';
import { resolveProp } from '@clearscore/helpers.resolve-props';

import cleanContext from '../helpers/clean-context-key';

const getTransactionsByAccountNumber = (state) => resolveProp('entities.transactionsByAccountNumber.byId', state) || {};
const getTransactions = (state) => resolveProp('entities.transactions.byId', state) || {};

export default createSelector(
    getTransactionsByAccountNumber,
    getTransactions,
    (transactionsByAccountNumber, transactions) => (contextKey, creditLimit, provider) => {
        const normalisedContextKey = cleanContext(contextKey);

        const accountNo = Object.keys(transactionsByAccountNumber).find((id) => {
            const accountId = transactionsByAccountNumber[id].accounts[0];
            const { providerId } = transactions[accountId].provider;
            return normalisedContextKey.includes(id) && providerId === provider.provider_id;
        });

        const accountMatch = accountNo && transactionsByAccountNumber[accountNo].accounts[0];

        const cardMatch =
            !accountMatch && provider && creditLimit
                ? Object.keys(transactions).find((id) => {
                      const bankAccount = transactions[id];
                      return (
                          resolveProp('provider.providerId', bankAccount) === provider.provider_id &&
                          resolveProp('balance.creditLimit', bankAccount) === creditLimit
                      );
                  })
                : undefined;

        return accountMatch || cardMatch;
    },
);
